<div>
  <div class="ui-g-12 p-0 mt-2 mb-1">
    <div class="ui-g-11 p-0 heading">
      <p class="fleet-heading text-left">Fleet override</p>
    </div>

    <div class="ui-g-1 p-0 heading text-right">
      <i class="icon-color far fa-edit pointer" (click)="openFleetPricingModal()"></i>
    </div>
  </div>

  <div class="ui-g-12 p-0 fleet-data text-left flex-wrap">
    <div class="ui-g-12 p-0 mt-2">
      <div class="ui-g-6 p-0 heading">
        <p class="m-0 white-space-nowrap text-left">Order discount</p>
      </div>

      <div *ngIf="!customer?.isOrderDiscOverride" class="fleet-value ui-g-6 p-0 text-right">
        Not applicable
      </div>
      <div *ngIf="customer?.isOrderDiscOverride" class="ui-g-6 p-0 text-right">
        <span *ngIf="customer?.customOrderDiscount?.type !== 'percentage'">
          {{customer?.customOrderDiscount?.value || 0 | currency: usd}}
        </span>
        <span *ngIf="customer?.customOrderDiscount?.type === 'percentage'">
          {{customer?.customOrderDiscount?.value || 0 }}%
        </span>
      </div>
    </div>

    <div class="ui-g-12 p-0 mt-2">
      <div class="ui-g-6 p-0 heading">
        <p class="m-0 white-space-nowrap text-left">Shop supplies override</p>
      </div>

      <div *ngIf="!customer?.isShopSuppliesOverride" class="fleet-value ui-g-6 p-0 text-right">
        Not applicable
      </div>
      <div *ngIf="customer?.isShopSuppliesOverride" class="ui-g-6 p-0 text-right">
        <span *ngIf="customer?.customShopSupplies?.type === 'percentage'">
          {{customer?.customShopSupplies?.value}}% - (Max fees: ${{customer.customShopSupplies.cap}})
        </span>

        <span *ngIf="customer?.customShopSupplies?.type !== 'percentage'">
          {{customer?.customShopSupplies?.value || 0 | currency: usd}}
        </span>
      </div>
    </div>

    <div *ngIf="isFleetTaxOverRideEnabled" class="ui-g-12 p-0 mt-2">
      <div class="ui-g-6 p-0 heading">
        <p class="m-0 white-space-nowrap text-left">Tax code override</p>
      </div>

      <div *ngIf="!customer?.isTaxCodeOverride" class="fleet-value ui-g-6 p-0 text-right">
        Not applicable
      </div>
      <div *ngIf="customer?.isTaxCodeOverride" class="ui-g-6 p-0 text-right">
        <span *ngIf="customer?.customTaxCode?._id">
          {{customer?.customTaxCode?.name}} - {{customer?.customTaxCode?.salesTaxRate}}
        </span>
      </div>
    </div>

    <div class="ui-g-12 p-0 mt-2">
      <div class="ui-g-6 p-0 heading">
        <p class="m-0 white-space-nowrap text-left">Labor rate override</p>
      </div>

      <div *ngIf="!customer?.isLaborRateOverride" class="fleet-value ui-g-6 p-0 text-right">
        Not applicable
      </div>
      <div *ngIf="customer?.isLaborRateOverride" class="ui-g-6 p-0 text-right">
        {{customer?.customLaborRate?.rate || 0 | currency: usd}}
      </div>
    </div>

    <!--  old -->
    <div *ngIf="!isAttributeBasedPricingEnable" class="ui-g-12 p-0 mt-2">
      <div class="ui-g-6 p-0 heading">
        <p class="m-0 white-space-nowrap text-left">Part pricing override</p>
      </div>

      <div *ngIf="!customer?.isPricingMatrixOverride" class="fleet-value ui-g-6 p-0 text-right">
        Not applicable
      </div>
      <div *ngIf="customer?.isPricingMatrixOverride" class="ui-g-6 p-0 text-right">
        {{customer?.customPartPricingMatrix?.name || 'Not Applicable'}}
      </div>
    </div>

    <!-- advance pricing  -->
    <div *ngIf="isAttributeBasedPricingEnable" class="ui-g-12 p-0 mt-2">
      <div class="ui-g-6 p-0 heading">
        <p class="m-0 white-space-nowrap text-left">Part pricing override</p>
      </div>

      <div *ngIf="!customer?.isPartPricingMatrixOverride" class="fleet-value ui-g-6 p-0 text-right">
        Not applicable
      </div>
      <div *ngIf="customer?.isPartPricingMatrixOverride" class="ui-g-6 p-0 text-right">
        {{customer?.customPartPricingMatrix?.name || 'Not Applicable'}}
      </div>
    </div>

    <div *ngIf="isAttributeBasedPricingEnable" class="ui-g-12 p-0 mt-2">
      <div class="ui-g-6 p-0 heading">
        <p class="m-0 white-space-nowrap text-left">Tire pricing override</p>
      </div>

      <div *ngIf="!customer?.isTirePricingMatrixOverride" class="fleet-value ui-g-6 p-0 text-right">
        Not applicable
      </div>
      <div *ngIf="customer?.isTirePricingMatrixOverride" class="ui-g-6 p-0 text-right">
        {{customer?.customTirePricingMatrix?.name || 'Not Applicable'}}
      </div>
    </div>
  </div>
</div>
